import React, { useEffect, useState } from 'react';
import OptionElement from './OptionElement';
import LeadFormSearch from './LeadFormSearch';
import styles from '../../../../../../styles/SearchPage.module.css';
import AppliedFiltersTag from '../../../../../components/AppliedFilters/AppliedFiltersTag';
import AppliedFiltersContainer from '../../../../../components/AppliedFilters/AppliedFiltersContainer';

export default function MultipleOptionSlide(props) {
    return (
        <div className="" key={props.element._id}>
       {props?.element?.selectedOptions?.length > 0 &&  <AppliedFiltersContainer>
                {
                    props.element.selectedOptions.map((item)=>(
                        <AppliedFiltersTag
                        id={item._id}
                        label={item.label}
                        value={item.value}
                        oncrossClick={()=>props.handleMultiOptionSelect(props.slideId,props.elementId,item._id,item.value)}
                        />
                    ))
                }
            </AppliedFiltersContainer>}
            <div className="text-center">
                <h3>{props.element.textElementName}</h3>
            </div>
            {props.element.isSearchAllowed ? (
                <LeadFormSearch
                    handleSearchChange={async (qtext)=>{await props.handleOptionSearch(qtext,props.element,props.slideId,props.elementId)}}
                    qtext={props.qtext}
                    placeholder={props.element.searchPlaceHolder}
                />
            ) : null}
            <div className="vm-leadform-option-element-style">
                {props.element.options &&
                    props.element.options.length > 0 &&
                    props.element.options.map((item) => (
                        <OptionElement
                            slideId={props.slideId}
                            elementId={props.elementId}
                            key={item._id}
                            item={item}
                            handleOptionSelect={props.handleMultiOptionSelect}
                            element={props.element}
                            selectedIcon={props.selectedIcon}
                            icon={props.icon}
                        />
                    ))}
            </div>
        </div>
    );
}

